import React, { Component } from "react";
import {
  Row,
  Col,
  Input,
  Button,
  Card,
  CardBody,
  InputGroupAddon,
  FormGroup
} from "reactstrap";
import _ from "lodash";
import { Redirect, withRouter } from '../../utils/router-compat';
import classnames from "classnames";
import Sidebar from "react-sidebar";
import Ionicon from "react-ionicons";
import "./../SalesReport/SalesReport.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarAlt } from "@fortawesome/free-solid-svg-icons";
import StorageService from "../../services/Storage";
import CustomSpinner from "../../components/CustomSpinner/CustomSpinner";
import { downlodFile } from "../../utils/utils";
import AddEditActivity from "../../components/ActivityReport/AddEditActivity";
import ActivityReportDataTableFM from "../../components/ActivityReport/ActivityReportDataTableFM";
import ActivityReportService from "../../services/ActivityReportService";
import ActivityDetail from "../../components/ActivityReport/ActivityDetail";
import ActivityReportDataTableZFM from "../../components/ActivityReport/ActivityReportDataTableZFM";
import ModalService from "../../services/ModalService";
import "./ActivityReport.css";
import { messages } from "../../constants/constant.message";
import { Roles } from "../../constants/constant.role";
const { ERROR_MESSAGE } = messages.COMMON;
class ActivityReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      years: this.getYears(),
      months: this.getMonths(),
      zoneName: "All India",
      selectedYear: new Date().getFullYear(),
      selectedMonth: this.getSelectedMonth(),
      userDetail: StorageService.getUserDetail(),
      sidebarOpen: false,
      redirectToMemberSalesDetail: false,
      isMonthPickerOpen: false,
      isLoading: false,
      fleetReportFM: [],
      fleetReportZFM: [],
      totalFleetReportFM: {
        heal_the_wheel: 0,
        heal_the_wheel_achievement: 0,
        heal_the_wheel_percent: 0,
        driver_training: 0,
        driver_training_achievement: 0,
        driver_training_percent: 0,
        scrap_analysis: 0,
        scrap_analysis_achievement: 0,
        scrap_analysis_percent: 0
      },
      selectedMember: {},
      addEditActivityData: {},
      isCheckSpacficFM: false,
      spacifcFMObj: {},
      zone: "all"
    };

    // isCheckSpacficFM: true,
    //   fm_id: '60a06c4d-e3e9-48ec-8213-e4eed98cdf82'
  }

  componentDidMount() {
    let { isLoading, isMonthPickerOpen } = this.state;
    isLoading = true;
    this.setState({ isLoading });
    this.callGetAPIs();

    const that = this;
    window.addEventListener("click", function handleClick(e) {
      if (
        (document.getElementById("monthYearCalendarDiv") &&
          document.getElementById("monthYearCalendarDiv").contains(e.target)) ||
        (document.getElementById("monthYearCalendarInput") &&
          document.getElementById("monthYearCalendarInput").contains(e.target))
      ) {
        // Clicked in box
        isMonthPickerOpen = true;
        that.setState({ isMonthPickerOpen });
      } else {
        isMonthPickerOpen = false;
        that.setState({ isMonthPickerOpen });
        // Clicked outside the box
      }
    });
  }

  openMonthPicker = () => {
    let { isMonthPickerOpen } = this.state;
    isMonthPickerOpen = !isMonthPickerOpen;
    this.setState({ isMonthPickerOpen });
  };

  getYears = () => {
    const arr = [];
    for (let i = new Date().getFullYear(); i >= 1970; i--) {
      arr.push(i);
    }

    return arr;
  };

  getMonths = () => {
    return [
      {
        label: "Jan",
        value: 1
      },
      {
        label: "Feb",
        value: 2
      },
      {
        label: "Mar",
        value: 3
      },
      {
        label: "Apr",
        value: 4
      },
      {
        label: "May",
        value: 5
      },
      {
        label: "Jun",
        value: 6
      },
      {
        label: "Jul",
        value: 7
      },
      {
        label: "Aug",
        value: 8
      },
      {
        label: "Sep",
        value: 9
      },
      {
        label: "Oct",
        value: 10
      },
      {
        label: "Nov",
        value: 11
      },
      {
        label: "Dec",
        value: 12
      }
    ];
  };

  getSelectedMonth = () => {
    return _.find(this.getMonths(), { value: new Date().getMonth() + 1 });
  };

  handleYearChange = e => {
    let { selectedYear, isLoading } = this.state;
    selectedYear = e.target.value;
    isLoading = true;
    this.setState({ selectedYear, isLoading }, () => {
      this.callGetAPIs();
    });
  };

  handleMonthChange = obj => {
    let { selectedMonth, isMonthPickerOpen, isLoading } = this.state;
    selectedMonth = obj;
    isLoading = true;
    isMonthPickerOpen = !isMonthPickerOpen;

    this.setState({ selectedMonth, isMonthPickerOpen, isLoading }, () => {
      this.callGetAPIs();
    });
    if (this.refActivityReportDataTableZFM) {
      this.refActivityReportDataTableZFM.resetData();
    }
  };

  openCloseSideBar = flag => {
    let { sidebarOpen, addEditActivityData } = this.state;
    sidebarOpen = !sidebarOpen;
    if (flag) {
      this.callGetAPIs();
      this.resetFilterActivityReportFM();
    }
    if (!sidebarOpen) {
      addEditActivityData = {};
    }
    this.setState({ sidebarOpen, addEditActivityData });
  };

  goToMemberSalesReport = obj => {
    const { selectedMember } = this.state;
    let { redirectToMemberSalesDetail } = this.state;
    selectedMember.uuid = window.btoa(obj.uuid);
    selectedMember.name = window.btoa(obj.business_name);
    selectedMember.memberId = window.btoa(obj.member_id);
    selectedMember.location = window.btoa(obj.region_name);
    redirectToMemberSalesDetail = true;
    this.setState({ redirectToMemberSalesDetail, selectedMember });
  };

  callGetAPIs = async () => {
    const { userDetail } = this.state;
    if (userDetail.type === Roles.FLEET_MANAGER_ROLE || this.state.isCheckSpacficFM) {
      let reqData = {
        page: 1,
        pagesize: 10,
        downloadReport: false
      };
      this.getActivity(reqData);
      this.getTotalActivityCount(reqData);
    } else if (
      userDetail.type === Roles.ZONAL_FLEET_MANAGER_ROLE ||
      !this.state.isCheckSpacficFM
    ) {
      this.getZonalFleetActivityFM({});
      this.getTotalActivityReportZFMCount({});
    }
  };

  searchFleetSalesFm = reqData => {
    this.getActivity(reqData);
    this.getTotalActivityCount(reqData);
  };
  searchZFM = reqData => {
    this.getZonalFleetActivityFM(reqData);
    this.getTotalActivityReportZFMCount(reqData);
  };
  resetFilterActivityReportFM = () => {
    if (this.refActivityReportDataTableFM) {
      this.refActivityReportDataTableFM.resetFilter();
    }
  };

  getSpacificFMData = async data => {
    if (data && Object.keys(data).length > 0) {
      await this.setState({
        spacifcFMObj: {
          id: data.fm_id,
          business_name: data.business_name
        },
        isCheckSpacficFM: true
      });
    } else {
      await this.setState({
        spacifcFMObj: {},
        isCheckSpacficFM: false
      });
    }
    this.callGetAPIs();
  };

  getActivity = async reqParam => {
    const { spacifcFMObj } = this.state;
    let { fleetReportFM, isLoading } = this.state;
    try {
      isLoading = true;
      this.setState({ isLoading });
      let reqData = {
        page: reqParam.page,
        pagesize: reqParam.pagesize,
        download_report: reqParam.download_report,
        search: reqParam.search,
        activity_type: reqParam.activity_type ? reqParam.activity_type : 1
      };

      if (spacifcFMObj && Object.keys(spacifcFMObj).length > 0) {
        reqData.id = spacifcFMObj.id;
      }
      if (reqParam.from_date) {
        reqData.from_date = reqParam.from_date;
      }
      if (reqParam.to_date) {
        reqData.to_date = reqParam.to_date;
      }
      let { data } = await ActivityReportService.getActivity(reqData);

      if (reqParam.download_report && data) {
        const link = document.createElement("a");
        link.href = data.data.file;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } else if (data) {
        fleetReportFM = data.data;
        fleetReportFM.pageCount =
          Math.trunc(fleetReportFM.total_count / 10) + 1;
        fleetReportFM.page = reqParam.page;
      }
      isLoading = false;
      this.setState({ isLoading, fleetReportFM });
    } catch (e) {
      isLoading = false;
      this.setState({ isLoading });
      let err =
        e.response &&
          e.response.data &&
          e.response.data.error &&
          e.response.data.error[0]
          ? e.response.data.error[0]
          : null;
      const message = err && err.message ? err.message : ERROR_MESSAGE;
      ModalService.openAlert("", message, "error");
    }
  };

  getTotalActivityCount = async () => {
    const { spacifcFMObj } = this.state;
    let reqData = {};
    if (spacifcFMObj && Object.keys(spacifcFMObj).length > 0) {
      reqData.id = spacifcFMObj.id;
    }
    let { totalFleetReportFM } = this.state;
    try {
      const { data } = await ActivityReportService.getTotalActivityCount(
        reqData
      );
      if (data) {
        totalFleetReportFM = data.data;
      }
      this.setState({ totalFleetReportFM });
    } catch (error) { }
  };

  getTotalActivityReportZFMCount = async reqParam => {
    const { selectedMonth, selectedYear, zone, userDetail } = this.state;
    let reqData = {
      m: selectedMonth.value,
      y: selectedYear
    };
    if (userDetail.type !== Roles.ZONAL_FLEET_MANAGER_ROLE) {
      reqData["zone"] = zone;
    }
    if (reqParam.q) {
      reqData.q = reqParam.q;
    }
    let { totalFleetReportFM } = this.state;
    try {
      const {
        data
      } = await ActivityReportService.getTotalActivityReportZFMCount(reqData);
      if (data) {
        totalFleetReportFM = data.data;
      }
      await this.setState({ totalFleetReportFM });
    } catch (error) { }
  };

  getZonalFleetActivityFM = async reqParam => {
    const { selectedMonth, selectedYear, zone, userDetail } = this.state;
    let { fleetReportZFM, isLoading } = this.state;
    let reqData = {
      m: selectedMonth.value,
      y: selectedYear
    };
    if (userDetail.type !== Roles.ZONAL_FLEET_MANAGER_ROLE) {
      reqData["zone"] = zone;
    }
    if (reqParam.download_report) {
      reqData.download_report = true;
    }
    if (reqParam.q) {
      reqData.q = reqParam.q;
    }
    try {
      isLoading = true;
      this.setState({ isLoading });
      const { data } = await ActivityReportService.getActivityReportZFM(
        reqData
      );
      if (data) {
        if (reqParam.download_report) {
          const { file } = data.data;
          downlodFile(file);
          this.setState({ isLoading: false });
          return;
        }
        fleetReportZFM = data.data.report;
      }
      isLoading = false;
      this.setState({ isLoading, fleetReportZFM });
    } catch (error) {
      isLoading = false;
      this.setState({ isLoading });
    }
  };

  handlePageClick = (search, e) => {
    let { isLoading } = this.state;
    isLoading = true;
    this.setState({ isLoading });
    this.getFleetSalesFM(e.selected + 1, 10, false, search);
  };

  openTargetSalesPage = () => {
    this.props.history.push("/set-activity-target");
  };

  setEditData = async data => {
    await this.setState({
      addEditActivityData: data,
      sidebarOpen: true
    });
  };

  openActivityDetail = data => {
    this.refs.childActivityDetail.toggle(data);
  };

  isLoadingData = isLoading => {
    this.setState({
      isLoading: isLoading
    });
  };

  onChangeZone = e => {
    if (e.target.value) {
      if (e.target.value == "sz1") {
        this.setState({ zoneName: "South 1" });
      } else if (e.target.value == "sz2") {
        this.setState({ zoneName: "South 2" });
      } else if (e.target.value == "ez") {
        this.setState({ zoneName: "East" });
      } else if (e.target.value === "nz") {
        this.setState({ zoneName: "North" });
      } else if (e.target.value === "wz") {
        this.setState({ zoneName: "West" });
      }
    } else {
      this.setState({ zoneName: "All India" });
    }

    this.setState(
      {
        zone: e.target.value
      },
      () => {
        this.callGetAPIs();
      }
    );
  };

  render() {
    const {
      isLoading,
      selectedMember,
      totalFleetReportFM,
      fleetReportFM,
      fleetReportZFM,
      userDetail,
      redirectToMemberSalesDetail,
      isMonthPickerOpen,
      years,
      months,
      selectedMonth,
      selectedYear,
      sidebarOpen
    } = this.state;
    return (
      <div id="sales">
        {redirectToMemberSalesDetail && (
          <Redirect
            to={{
              pathname: "/memberSalesDetail",
              search: `uuid=${selectedMember.uuid}&memberId=${selectedMember.memberId}&name=${selectedMember.name}&location=${selectedMember.location}&month=${selectedMonth.value}&year=${selectedYear}&label=${selectedMonth.label}`
            }}
          />
        )}
        {isLoading && <CustomSpinner />}
        <Row>
          {!this.state.isCheckSpacficFM && (
            <Col className="offtake-title">Activity Report</Col>
          )}
          {this.state.isCheckSpacficFM && (
            <Col>
              <span
                className="prev-page-link cursor-pointer"
                onClick={() => this.getSpacificFMData({})}
              >
                Activity Reportas
              </span>
              <span>
                <Ionicon
                  icon="ios-arrow-forward"
                  fontSize="34px"
                  color="#fdbb1f"
                />
              </span>
              <span className="current-page">
                {this.state.spacifcFMObj.business_name}
              </span>
            </Col>
          )}
          <Col className="offtake-title">
            {userDetail.type === Roles.FLEET_MANAGER_ROLE && (
              <Button
                type="button"
                className="mb-1 mr-1 btn-pill action-button profile-save-button pull-right"
                color="warning"
                style={{ cursor: "pointer", width: "auto" }}
                onClick={this.openCloseSideBar}
              >
                Add New Activity
              </Button>
            )}

            {userDetail.type === Roles.ZONAL_FLEET_MANAGER_ROLE &&
              !this.state.isCheckSpacficFM && (
                <Button
                  type="button"
                  className="mb-1 mr-1 btn-pill action-button profile-save-button pull-right"
                  color="warning"
                  style={{ cursor: "pointer", width: "auto" }}
                  onClick={this.openTargetSalesPage}
                >
                  Set Activity Target
                </Button>
              )}
          </Col>
        </Row>
        <br />
        {userDetail.type !== Roles.FLEET_MANAGER_ROLE && !this.state.isCheckSpacficFM && (
          <Row>
            <Col xl="3" md="3" sm="3" xs="3">
              <div
                id="monthYearCalendarInput"
                className="d-flex-row vehical-sku-id-search"
              >
                <Input
                  className="form-control"
                  type="text"
                  name="sap_id"
                  value={
                    selectedMonth && `${selectedMonth.label} ${selectedYear}`
                  }
                  onClick={this.openMonthPicker}
                  readOnly
                  style={{ background: "white" }}
                  placeholder="Select Month"
                />
                <InputGroupAddon
                  onClick={this.openMonthPicker}
                  addonType="append"
                  className="serach-icon"
                  style={{ marginTop: "0px" }}
                >
                  <div
                    className="input-group-text"
                    style={{ paddingRight: "5px", marginTop: "-1px" }}
                  >
                    <FontAwesomeIcon icon={faCalendarAlt} />
                  </div>
                </InputGroupAddon>
              </div>
            </Col>
            {this.state.userDetail.type === Roles.HEAD_OFFICE_BAADSHAH_ROLE && (
              <Col xl="2" md="2" sm="3" xs="3">
                <FormGroup>
                  <select
                    name="month"
                    className="form-control cursor-pointer"
                    value={this.state.zone}
                    style={{
                      fontSize: "13px",
                      width: "140px",
                      color: "#6e777f",
                      marginLeft: "-20px"
                    }}
                    onChange={e => {
                      this.onChangeZone(e);
                    }}
                  >
                    <option value="all" selected>
                      All India
                    </option>
                    <option value="nz" selected>
                      North
                    </option>
                    <option value="sz1">South 1</option>
                    <option value="sz2">South 2</option>
                    <option value="ez">East</option>
                    <option value="wz">West</option>
                  </select>
                </FormGroup>
              </Col>
            )}
          </Row>
        )}

        {isMonthPickerOpen && (
          <Row
            id="monthYearCalendarDiv"
            style={{ position: "absolute", zIndex: "118" }}
          >
            <Col xl="4" md="4" sm="4" xs="4">
              <Card style={{ width: "97%" }}>
                <CardBody>
                  <Row>
                    <Col>
                      <select
                        className="form-control"
                        name="selectedYear"
                        onChange={e => this.handleYearChange(e)}
                        value={selectedYear}
                      >
                        {(years || []).map(year => (
                          <option key={year}>{year}</option>
                        ))}
                      </select>
                    </Col>
                  </Row>

                  <Row className="c-top-10">
                    {(months || []).map(month => (
                      <Col xl="4" md="4" sm="3" xs="3" key={month.value}>
                        <div>
                          <Button
                            className="btn-month"
                            color="default"
                            onClick={e => this.handleMonthChange(month)}
                          >
                            {month.label}
                          </Button>
                        </div>
                      </Col>
                    ))}
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
        )}

        {StorageService.getUserDetail().type === Roles.HEAD_OFFICE_BAADSHAH_ROLE && (
          <Col style={{ paddingLeft: "0px" }}>
            <div className="zoneFont">
              Showing results of{" "}
              {this.state.zoneName === "All India"
                ? this.state.zoneName
                : this.state.zoneName + " Zone"}
              .
            </div>
          </Col>
        )}

        <Row style={{ marginTop: "20px" }}>
          <Col xl="4" md="4" sm="12" xs="12">
            <div
              className={classnames(
                { "mr-3": !this.isMobile },
                "fm-points-card total-points-card"
              )}
              style={{ paddingBottom: "0px" }}
            >
              <Row>
                <Col xl="8" md="8" sm="12" xs="12">
                  <div className="fm-trucks">Heal The Wheel</div>
                </Col>
                {/* <Col>
                  <div className="direct-indirect-sales-value">% Achievement</div>
                </Col> */}
              </Row>

              <Row style={{ marginLeft: "7px", marginTop: "18px" }}>
                <Col xl="7" md="6" sm="12" xs="12">
                  <div className="direct-sales-label">
                    Total Activities Assigned -
                  </div>
                  <br />
                  <div className="direct-sales-label">
                    Completed Activities -{" "}
                  </div>
                </Col>
                <Col xl="4" md="4" sm="12" xs="12">
                  <div className="direct-indirect-sales-value">
                    {totalFleetReportFM.heal_the_wheel ? (
                      totalFleetReportFM.heal_the_wheel
                    ) : (
                      <span className="no-data-hypen mt-mb-10"></span>
                    )}
                  </div>
                  <br />
                  <div className="direct-indirect-sales-value">
                    {totalFleetReportFM.heal_the_wheel_achievement ? (
                      totalFleetReportFM.heal_the_wheel_achievement
                    ) : (
                      <span className="no-data-hypen mt-mb-10"></span>
                    )}
                  </div>
                </Col>
              </Row>

              <Row
                className="c-top-10"
                style={{
                  marginRight: "0px",
                  marginLeft: "0px",
                  background: "white",
                  paddingBottom: "10px",
                  paddingTop: "10px"
                }}
              >
                <Col xl="7" md="6" sm="12" xs="12">
                  <div className="direct-sales-label">
                    &nbsp;% Achievement -
                  </div>
                </Col>
                <Col xl="4" md="4" sm="12" xs="12">
                  <div className="direct-indirect-sales-value ml-1">
                    &nbsp;&nbsp;
                    {totalFleetReportFM.heal_the_wheel_percent ? (
                      totalFleetReportFM.heal_the_wheel_percent
                    ) : (
                      <span className="no-data-hypen mt-n10-ml-10"></span>
                    )}
                  </div>
                </Col>
              </Row>
            </div>
          </Col>

          <Col xl="4" md="4" sm="12" xs="12">
            <div
              className={classnames(
                { "mr-3": !this.isMobile },
                "fm-points-card total-points-card"
              )}
              style={{ paddingBottom: "0px" }}
            >
              <Row>
                <Col xl="12" md="12" sm="12" xs="12">
                  <div className="fm-trucks">Driver Training / Digital Training</div>
                </Col>
                {/* <Col>
                  <div className="direct-indirect-sales-value">% Achievement</div>
                </Col> */}
              </Row>

              <Row style={{ marginLeft: "7px", marginTop: "18px" }}>
                <Col xl="7" md="6" sm="12" xs="12">
                  <div className="direct-sales-label">
                    Total Activities Assigned -
                  </div>
                  <br />
                  <div className="direct-sales-label">
                    Completed Activities -{" "}
                  </div>
                </Col>
                <Col xl="4" md="4" sm="12" xs="12">
                  <div className="direct-indirect-sales-value">
                    {totalFleetReportFM.driver_training ? (
                      totalFleetReportFM.driver_training
                    ) : (
                      <span className="no-data-hypen mt-mb-10"></span>
                    )}
                  </div>
                  <br />
                  <div className="direct-indirect-sales-value">
                    {totalFleetReportFM.driver_training_achievement ? (
                      totalFleetReportFM.driver_training_achievement
                    ) : (
                      <span className="no-data-hypen mt-mb-10"></span>
                    )}
                  </div>
                </Col>
              </Row>

              <Row
                className="c-top-10"
                style={{
                  marginRight: "0px",
                  marginLeft: "0px",
                  background: "white",
                  paddingBottom: "10px",
                  paddingTop: "10px"
                }}
              >
                <Col xl="7" md="6" sm="12" xs="12">
                  <div className="direct-sales-label">
                    &nbsp;% Achievement -
                  </div>
                </Col>
                <Col xl="4" md="4" sm="12" xs="12">
                  <div className="direct-indirect-sales-value ml-1">
                    &nbsp;&nbsp;
                    {totalFleetReportFM.driver_training_percent ? (
                      totalFleetReportFM.driver_training_percent
                    ) : (
                      <span className="no-data-hypen mt-n10-ml-10"></span>
                    )}
                  </div>
                </Col>
              </Row>
            </div>
          </Col>

          <Col xl="4" md="4" sm="12" xs="12">
            <div
              className={classnames(
                { "mr-3": !this.isMobile },
                "fm-points-card total-points-card"
              )}
              style={{ paddingBottom: "0px" }}
            >
              <Row>
                <Col xl="8" md="8" sm="12" xs="12">
                  <div className="fm-trucks">Scrap Analysis</div>
                </Col>
                {/* <Col>
                  <div className="direct-indirect-sales-value">% Achievement</div>
                </Col> */}
              </Row>

              <Row style={{ marginLeft: "7px", marginTop: "18px" }}>
                <Col xl="7" md="6" sm="12" xs="12">
                  <div className="direct-sales-label">
                    Total Activities Assigned -
                  </div>
                  <br />
                  <div className="direct-sales-label">
                    Completed Activities -{" "}
                  </div>
                </Col>
                <Col xl="4" md="4" sm="12" xs="12">
                  <div className="direct-indirect-sales-value">
                    {totalFleetReportFM.scrap_analysis ? (
                      totalFleetReportFM.scrap_analysis
                    ) : (
                      <span className="no-data-hypen mt-mb-10"></span>
                    )}
                  </div>
                  <br />
                  <div className="direct-indirect-sales-value">
                    {totalFleetReportFM.scrap_analysis_achievement ? (
                      totalFleetReportFM.scrap_analysis_achievement
                    ) : (
                      <span className="no-data-hypen mt-mb-10"></span>
                    )}
                  </div>
                </Col>
              </Row>

              <Row
                className="c-top-10"
                style={{
                  marginRight: "0px",
                  marginLeft: "0px",
                  background: "white",
                  paddingBottom: "10px",
                  paddingTop: "10px"
                }}
              >
                <Col xl="7" md="6" sm="12" xs="12">
                  <div className="direct-sales-label">
                    &nbsp;% Achievement -
                  </div>
                </Col>
                <Col xl="4" md="4" sm="12" xs="12">
                  <div className="direct-indirect-sales-value ml-1">
                    &nbsp;&nbsp;
                    {totalFleetReportFM.scrap_analysis_percent ? (
                      totalFleetReportFM.scrap_analysis_percent
                    ) : (
                      <span className="no-data-hypen mt-n10-ml-10"></span>
                    )}
                  </div>
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
        <Row className="c-top-20">
          <Col
            xl={
              userDetail.type === Roles.FLEET_MANAGER_ROLE || this.state.isCheckSpacficFM
                ? "10"
                : "12"
            }
            md="12"
            xs="12"
          >
            {(userDetail.type === Roles.FLEET_MANAGER_ROLE ||
              this.state.isCheckSpacficFM) && (
              <ActivityReportDataTableFM
                ref={r => (this.refActivityReportDataTableFM = r)}
                setEditData={this.setEditData}
                fleetReportFM={fleetReportFM}
                getFleetSalesFM={this.getActivity}
                goToMemberSalesReport={this.goToMemberSalesReport}
                searchFleetSalesFm={this.searchFleetSalesFm}
                handlePageClick={this.handlePageClick}
                userDetail={userDetail}
                isLoadingData={this.isLoadingData}
                openActivityDetail={this.openActivityDetail}
              />
            )}
            {(userDetail.type === Roles.ZONAL_FLEET_MANAGER_ROLE ||
              userDetail.type === Roles.HEAD_OFFICE_BAADSHAH_ROLE) &&
              !this.state.isCheckSpacficFM && (
                <ActivityReportDataTableZFM
                  ref={r => (this.refActivityReportDataTableZFM = r)}
                  searchZFM={this.searchZFM}
                  fleetSales={fleetReportZFM}
                  goToMemberSalesReport={this.goToMemberSalesReport}
                  getSpacificFMData={this.getSpacificFMData}
                  downloadReport={this.downloadZonalFleetSalesReport}
                />
              )}
          </Col>
        </Row>

        <Row>
          <Col>
            {sidebarOpen && (
              <Sidebar
                sidebar={
                  <AddEditActivity
                    addEditActivityData={this.state.addEditActivityData}
                    openCloseSideBar={this.openCloseSideBar}
                  />
                }
                open={sidebarOpen}
                sidebarClassName="subsdiaries-sidebar"
                pullRight
                styles={{
                  sidebar: { background: "white", height: "100%", width: "51%" }
                }}
              />
            )}
          </Col>
        </Row>
        <ActivityDetail
          ref="childActivityDetail"
          from="activity-rerort"
          closeModal={this.closeInviteFleet}
        />
      </div>
    );
  }
}

export default withRouter(ActivityReport);
